import { createGlobalStyle, css } from 'styled-components'
import { colors, sizes } from 'config/ui'
import './icons.css'
import './fonts.css'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import { getDisplayMode } from 'utils/hooks/use-is-pwa'

const isAppWebView = Boolean(global.webViewActive && window.ReactNativeWebView)
const isPwa = getDisplayMode().displayMode === 'standalone'

const globalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  html {
    overflow-x: clip;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: Averta, sans-serif;
    font-feature-settings: 'ss01' on, 'liga' off, 'clig' off;
    font-size: ${sizes.text}px;
    color: ${colors.darkGray};
    -webkit-font-smoothing: antialiased;
    overflow-x: clip;
  }

  input,
  textarea,
  button,
  select,
  a {
    -webkit-tap-highlight-color: transparent;
  }

  textarea {
    font-family: Averta,sans-serif;
    font-feature-settings: 'ss01' on, 'liga' off, 'clig' off;
  }

  #root {
    display: flex;
    flex-direction: column;
    min-height: 100dvh;

    @media print {
      display: none;
    }

    :has(.modular-content) {
      background-color: ${tokens.colors.dark0};
    }

  }

  #print {
    visibility: hidden;
    position: fixed;
    left: 0;
    top: 0;
    width: 0;
    height: 0;

    @media print {
      visibility: visible;
      width: 100%;
      height: auto;
      position: absolute;
    }
  }

  #modal {
    position: absolute;
    top: 0;
    z-index: 10000;
  }

  button, input {
    font-family: Averta, sans-serif;
    font-feature-settings: 'ss01' on, 'liga' off, 'clig' off;
  }

  p {
    font-size: ${sizes.paragraph}px;
    line-height: 24px;
  }

  ${[1, 2, 3, 4, 5].map(
    size => `
    h${size} {
      font-size: ${sizes.h[size]}px;
      color: ${colors.black};
    }
  `
  )}

  h5 {
    margin: 5px 0;
    color: ${colors.gray9};
  }

  /* quill */
  .ql-snow .ql-tooltip[data-mode="video"] {
    left: 0 !important;

    &:before {
      content: "Video:" !important;
    }

    > a.ql-action {
      &:after {
        content: "Salvar" !important;
      }
    }
  }

  .ql-container.ql-disabled .ql-tooltip.ql-hidden {
    display: none;
  }

  .ql-bubble.ql-disabled .ql-editor {
    padding: 0;
  }

  .ql-editor *{
    font-family: Averta, sans-serif;
    font-feature-settings: 'ss01' on, 'liga' off, 'clig' off;
  }

  .ql-editor ol,
  .ql-editor ul{
    padding-top: 16px!important;
  }

  .ql-editor a{
    color: ${colors.blue}!important;
  }

  .ql-editor ol li,
  .ql-editor ul li,
  .ql-editor ul li p{
    color: ${colors.gray7};
    font-size: 15px;
    line-height: 24px;
  }
  .ql-editor ol li,
  .ql-editor ul li{
    margin-bottom: 16px;
  }

  .ql-editor iframe{
    width: 520px;
    height:  295px;
  }

  .quill .ql-container .ql-editor p,
  .quill .ql-container .ql-editor p span{
    color: ${colors.gray7};
  }

  .quill .ql-container .ql-editor img{
    display: block;
    max-width: 100%;
  }

  /* Slider */
  .slick-slider
  {
      position: relative;

      display: block;
      box-sizing: border-box;

      -webkit-user-select: none;
        -moz-user-select: none;
          -ms-user-select: none;
              user-select: none;

      -webkit-touch-callout: none;
      -khtml-user-select: none;
      -ms-touch-action: pan-y;
          touch-action: pan-y;
      -webkit-tap-highlight-color: transparent;
  }

  .slick-list
  {
      position: relative;

      display: block;
      overflow: hidden;

      margin: 0;
      padding: 0;
  }
  .slick-list:focus
  {
      outline: none;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list
  {
    transform: translate3d(0, 0, 0);
  }

  .slick-track
  {
      position: relative;
      top: 0;
      left: 0;

      display: block;
  }
  .slick-track:before,
  .slick-track:after
  {
      display: table;

      content: '';
  }
  .slick-track:after
  {
      clear: both;
  }

  .slick-slide
  {
      display: none;
      float: left;

      height: 100%;
      min-height: 1px;
  }

  .slick-initialized .slick-slide
  {
      display: block;
  }

  .ReactVirtualized__Table__rowColumn {
    padding: 0 10px;
  }

  .__react_component_tooltip {
    font-size: 13px !important;
    border-radius: ${sizes.radius}px !important;
    padding: 4px 8px !important;
    opacity: 1 !important;
  }

  .__react_component_tooltip.type-dark {
    background-color: ${colors.gray7};
    max-width: 300px;
  }

  .__react_component_tooltip:after, .__react_component_tooltip:before {
    display: none !important;
  }


  .quill-multiple-choice-item {
    display: flex!important;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;

    .ql-container{
      min-height: 46px !important;
      width: calc(100% - 46px);
      border: 1px solid #dfe5e9!important;
      border-radius: 3px;
    }

    .ql-editor{
      border: none;
      min-height: 44px!important;

      &:before{
        font-size: 15px!important;
        font-style: normal!important;
        color: #9eaeb7!important;
        padding-top: 2px;
      }
    }

    &.quill-multiple-choice-item--is-correct{
      .ql-container{
        border: 1px solid #58d68d!important;
      }

      .ql-editor{
        &:before{
          color: #58d68d!important;
        }
      }
    }

    .ql-toolbar {
      border: 0 none !important;
      width: 30px;
      height: 30px;
      margin-left: 16px;
      padding: 0!important;

      span{
        margin: 0!important;
        padding: 0!important;
      }

      .ql-formats:first-child{
        display: none !important;
      }
      button {
        display: none !important;
        &.ql-image {
          display : block !important;
        }
      }

      .ql-image {
        &:before {
          font-family: 'icomoon' !important;
          speak: none;
          font-style: normal;
          font-weight: normal;
          font-variant: normal;
          text-transform: none;
          line-height: 1;

          /* Better Font Rendering =========== */
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          content: "\\e98f";
          font-size: 24px;
          color: #9eaeb7;
          transition: all .5s ease-in-out;


        }

        &:hover{
          &:before{
            color: #53656f;
          }
        }

        svg {
          display: none;
        }
      }
    }
  }

  .react-datepicker-popper{
    z-index: 5 !important;
  }

  body.league-empty {
    background-color: #8553f4;
    transition: background-color 100ms ease;
  }

  body.league-congratulations {
    background-color: #58D68D;
    transition: background-color 100ms ease;
  }

  /* Conpass */
  #conpass-tag button.conpassAssistant{
    z-index: 9 !important;
    right: 10px!important;
  }

  @media (min-width: ${sizes.sScreen}px) {
    div.shared-books-page {
      padding: 40px 20px 0 20px;
    }
  }

  // freshchat
  #fc_frame, #fc_frame.fc-widget-small{
    bottom: 100px !important;
    z-index: 10!important;

    ${() =>
      isAppWebView || isPwa
        ? css`
            display: none;
          `
        : ''}
  }

  // management
  [data-testid='client-container'] {
    display: flex !important;
    flex-direction: column !important;
    min-height: 78vh;

    @media (min-width: 1920px) {
      width: 100% !important;
      padding: 0 62px !important;
    }
  }

  //userWayWidget
  #userwayAccessibilityIcon {
        display: none;
      }

  body.webview {
    overflow-x: clip !important;
    overscroll-behavior-x: none;
    max-width: 100dvw;
  }

  body.webview #root {
    overflow-x: clip !important;
    max-width: 100dvw;
  }

  @supports (-webkit-touch-callout: none) {
    body.webview,
    body.webview #root {
      overflow-x: clip !important;
      -webkit-overflow-scrolling: touch;
    }
  }

  @-moz-document url-prefix() {
    body.webview,
    body.webview #root {
      overflow-x: clip !important;
    }
  }

  @media (hover: none) {
    [class*='CoverContainerstyles__CoverWrapper']:hover {
      transform: none !important;
    }
  }

  @media (max-width: ${tokens.breakpoints.desktop}px) {
    [class*='Modalstyles__ModalWrapper']:has(
        [class*='Modalstyles__StyledSheetHeader']
      ) {
      position: fixed !important;
      top: auto !important;
      bottom: 0 !important;
      left: 0 !important;
      right: 0 !important;
      max-height: 50dvh !important;
      display: flex !important;
      flex-direction: column !important;
      overflow: hidden !important;
      border-radius: 16px 16px 0 0;
      padding-bottom: env(safe-area-inset-bottom, 0px);
    }

    [class*='Modalstyles__ModalWrapper']:has(
        [class*='Modalstyles__StyledSheetHeader']
      ):has([class*='PureSelectstyles__']) {
      background: ${tokens.colors.white};
      padding-bottom: calc(
        var(--mobile-footer-height, 0px) + env(safe-area-inset-bottom, 0px)
      );
    }

    [class*='Modalstyles__ModalWrapper']:has(
        [class*='Modalstyles__StyledSheetHeader']
      )
      [class*='Modalstyles__ModalStyle'] {
      overflow-y: auto !important;
      flex: 1 1 auto;
      min-height: 0;
      overscroll-behavior: contain;
    }

    [class*='Modalstyles__ModalWrapper']:has(
        [class*='Modalstyles__StyledSheetHeader']
      )
      [class*='PureSelectstyles__SearchContainer'] {
      display: none !important;
    }

    [class*='Modalstyles__ModalWrapper']:has(
        [class*='Modalstyles__StyledSheetHeader']
      )
      :is([class^='Itemstyles__Container'], [class*=' Itemstyles__Container']) {
      min-height: 56px !important;
      flex-shrink: 0 !important;
    }
  }

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    [class*='DropdownEndstyles__Dropdown']
      :is([class^='Itemstyles__Container'], [class*=' Itemstyles__Container']) {
      height: auto !important;
      min-height: 0 !important;
      padding-top: ${tokens.spacing.verticalXsmall} !important;
      padding-bottom: ${tokens.spacing.verticalXsmall} !important;
    }

    [class*='DropdownEndstyles__Dropdown']
      [class*='PureSelectstyles__SearchContainer'] {
      box-sizing: border-box;
      padding: ${tokens.spacing.verticalXxsmall} ${
  tokens.spacing.horizontalXxsmall
};
    }
  }

  :focus-visible {
    outline: 2px solid ${tokens.colors.primary900};
    outline-offset: 2px;
  }

  [class*='Searchstyles__Container']:focus-within,
  [class*='PureSelectstyles__SearchContainer']:focus-within {
    outline: none;
    border: 2px solid ${tokens.colors.primary900};
  }

  [class*='Searchstyles__Container'] :focus-visible,
  [class*='PureSelectstyles__SearchContainer'] :focus-visible {
    outline: none;
  }

  [class*='TabItemstyles__TabItemStyle']:focus-visible,
  [class*='ContentTabNavItemstyles__StyledTabNav']:focus-visible {
    outline-offset: -2px;
    position: relative;
    z-index: 1;
  }
`

export default globalStyle
